import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Button, MasterDetailForm, Widget, Col, Row } from '@digital/ui';
import { enviarCartaContratada, verificaAnexoMarcadoComoExibirFornecedor } from '@app/api/sas/ordemCompra';
import { modalAcoesIdState, ordemCompraIdState, reloadVendorListState } from '../atoms';
import { Visibility, UploadFile } from '@app/components';
import { isObjEmpty, isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { SasProposta } from '@app/api/sas/sasProposta';
import { downloadArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { EStatusEnvioComunicacaoContratada } from '@app/enums';
import * as ui from '@digital/ui';
import * as Yup from 'yup';

interface Props {
  sasProposta: SasProposta;
}

const ModalEnvioComunicacaoContratada = ({ sasProposta }: Props) => {
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const setModalAcoesId = useSetRecoilState(modalAcoesIdState);

  const [exibirModal, setExibirModal] = useState(false);
  const [exibirModalJustificativa, setExibirModalJustificativa] = useState(false);

  const onDiscordar = () => {
    setExibirModal(false);
    setExibirModalJustificativa(false);
  };

  const onConcordar = (values: any) => {
    Modal.confirm({
      title: 'Confirmação Envio de Email',
      content:
        'Você deseja enviar este e-mail?',
      cancelText: 'Não',
      onCancel: () => {
        enviarReposta({ ...values, enviarEmail: false });
      },
      okText: 'Sim',
      onOk: () => {
        enviarReposta({ ...values, enviarEmail: true });
      },
    });
  };

  const enviarReposta = (values: any) => {
    const form = vtObjToFormData({ ...values, ordemCompraId });

    enviarCartaContratada(form)
      .then((data: any) => {
        if (data) {
          setReloadVendorList(!reloadVendorList);
          setModalAcoesId('');
        }
      }).finally(() => {
        setExibirModal(false);
        setExibirModalJustificativa(false);
      });
  };

  const verificaAnexoMarcado = (values: any) => {
    verificaAnexoMarcadoComoExibirFornecedor(ordemCompraId)
      .then((data: any) => {

        if (data.possuiDocumentoExibirFornecedor === false) {
          if (isObjEmpty(sasProposta.statusCartaConvite)) {
            Modal.confirm({
              title: 'Confirmar envio da comunicação à contratada',
              content:
                'Não existem documentos marcados como "Exibir Fornecedor". Deseja prosseguir mesmo assim?',
              cancelText: 'Cancelar',
              onCancel: () => { },
              okText: 'Confirmar',
              onOk: () => {
                setExibirModal(true);
              },
            });
          }

          if (sasProposta.statusCartaConvite == EStatusEnvioComunicacaoContratada.ENVIADA) {
            setExibirModal(true);
          }

        } else {
          setExibirModal(true);
        }

      });
  };

  return (
    <>
      <Visibility visible={isObjEmpty(sasProposta.statusCartaConvite) || sasProposta.statusCartaConvite == EStatusEnvioComunicacaoContratada.ENVIADA}  >
        <Tooltip title='Enviar' >
          <Button icon='commons-ok'
            style={{ marginRight: '5px' }}
            onClick={verificaAnexoMarcado} />
        </Tooltip>
      </Visibility>

      <Visibility visible={isObjEmpty(sasProposta.statusCartaConvite) || sasProposta.statusCartaConvite == EStatusEnvioComunicacaoContratada.NAO_ENVIADA} >
        <Tooltip title='Não Enviar' >
          <Button icon='commons-cancel' onClick={() => {
            setExibirModalJustificativa(true);
          }
          } />
        </Tooltip>
      </Visibility>
      <Visibility visible={exibirModalJustificativa} >
        <Modal title="Justificativa" width="680px" visible={exibirModalJustificativa} onCancel={() => setExibirModalJustificativa(false)} footer={null}>
          <MasterDetailForm
            initialValues={{ resposta: false, justificativa: sasProposta.justificativaNaoEnvioCartaContratada }}
            key={`formJustificativa_${sasProposta.id}`}
            actions={[
              <Button key="discordarBtn" type="link" onClick={() => onDiscordar()}>
                Cancelar
              </Button>,
              <Visibility visible={isObjEmpty(sasProposta.statusCartaConvite)} >
                <ui.FormSubmitButton title='Confirmar' noIcon key="concordarBtn" type="primary" onClick={enviarReposta} />
              </Visibility>
            ]}

            validationSchema={
              Yup.object().shape({
                justificativa: Yup.string().required('Campo obrigatório'),
              })
            }
          >
            <Widget>
              <Row>
                <ui.FormTextArea
                  name="justificativa"
                  span={12}
                  rows={4}
                  required
                  disabled={isObjNotEmpty(sasProposta.statusCartaConvite)}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <UploadFile
                    idDoComponente='arquivo-ModalEnvioComunicacaoContratada'
                    type='primary'
                    hasFile={false}
                    hasLabel={true}
                    icon='ui-upload'
                    disabled={isObjNotEmpty(sasProposta.statusCartaConvite)}
                  />
                </Col>
                <Col span={6}>
                  {sasProposta.anexoNaoEnviarComunicacaoContratada && (
                    <Button
                      icon='ui-download'
                      type='primary'
                      onClick={() => downloadArquivo(sasProposta.anexoNaoEnviarComunicacaoContratada.id, sasProposta.anexoNaoEnviarComunicacaoContratada.nome)}
                    />
                  )}
                </Col>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>

      <Visibility visible={exibirModal} >
        <Modal title="Enviar Comunicação à Contratada" visible={exibirModal} onCancel={() => setExibirModal(false)} footer={null}>
          <MasterDetailForm
            initialValues={{ resposta: true, tipoAditivo: sasProposta.tipoAditivoEnvioCartaContratada }}
            key={`formEnviarComunicacaoContratada_${sasProposta.id}`}
            validationSchema={
              Yup.object().shape({
                tipoAditivo: Yup.string().required('Campo obrigatório'),
              })
            }
            actions={[
              <Button key="discordarBtn" title='Cancelar' type="link" onClick={() => onDiscordar()} />,
              <Visibility visible={isObjEmpty(sasProposta.statusCartaConvite)} >
                <ui.FormSubmitButton title='Confirmar' noIcon key="concordarBtn" type="primary" onClick={onConcordar} />
              </Visibility>
            ]}
          >
            <Widget >
              <Row>
                <Col span={6}>
                  <ui.FormSelect name="tipoAditivo" label="Tipo de Aditivo" span={12} disabled={isObjNotEmpty(sasProposta.statusCartaConvite)}
                    options={[
                      { value: 'valor', text: 'Valor' },
                      { value: 'prazo', text: 'Prazo' },
                      { value: 'prazoValor', text: 'Prazo e Valor' },
                      { value: 'remanejamentoVerbas', text: 'Remanejamento de Verbas' },
                      { value: 'clausulas', text: 'Cláusulas' },
                    ]} />
                </Col>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>
    </>
  );
};


export default ModalEnvioComunicacaoContratada;
